import "./extendedWrapper.css"

export default function ExtendedWrapper({children}) {
    return (
        <div className="extendedWrapper">{children}</div>
    )
}